<template>
    <div class="filter-search-form note note-info note-bordered margin-bottom-20">  
        <div class="row margin-bottom-20">
            <div class="col-md-9">
                <div class="col-md-9">
                    <div class="col-md-12">
                        <label class="filtro-label-avancado">Perfil de Filtros</label>
                        <wes-Lookup
                            ref="lookupPerfil"
                            entityName="FN_GERENCIAISPERFIS"
                            resultFields="NOME"
                            whereClauseSessionKey="lookupPerfilOrcamentoWhere"
                            :placeholders="getPlaceHoldersPerfil()"
                            :enabled="isTreeViewLoaded()"
                            v-on:change="selecionarPerfil"
                            v-on:mounted="limparPerfilSelecionado"
                            v-on:clear="limparPerfilSelecionado">
                        </wes-Lookup>
                    </div>
                </div>
                <div @click="actionsClick" class="filtro-gerenciais-right-actions col-md-3">
                    <label class="filtro-label-avancado">Período</label>
                    <transition name="slide-fade">
                        <span v-if="isDateError" class="badge badge-danger">
                            Data inicial deve ser menor que data final
                        </span>
                    </transition>
                    <wes-date-range-button :gerarEnabled="isTreeViewLoaded()" startView=0 buttonDescription="Gerar" v-on:error-input="onErrorDateRange" :startDate="getMinDate()" :endDate="getMaxDate()" v-on:apply="applyFilter" key="t1">
                    </wes-date-range-button>
                </div>
            </div>
             <div class="col-md-3 filtro-gerenciais-actions collapsible" data-toggle="collapse" data-parent="false" data-target="#filtro-body">
                <div style="padding-top:20px">
				    <p style="font-size:14px; text-align: right;">Filtro avançado <i class="fa fa-chevron-down font-black" style="cursor:pointer;" title="Clique para expandir o menu de filtros."></i></p>
			    </div>
            </div>
        </div>
        <div id="filtro-body" class="row collapse in">
            <div class="col-md-3" style="min-height:300px">
                <ul class="nav nav-tabs tabs-left tabbable-line">
                    <li class="active">
                        <a href="#treeview_empresaFilial" data-toggle="tab">
                            <i class="fa fa-building"></i> Empresa e Filiais <span v-if="(getTotalSelectedEmpresaFilial() > 0) && !isEmpresaTreeViewLoading()"
                                                                                   class="badge badge-default">{{ getTotalSelectedEmpresaFilial() }}</span>
                            <transition name="slide-fade">
                                <span v-if="isEmpresaTreeViewLoading()" class="fa fa-spinner fa-spin"></span>
                            </transition>
                            <transition name="slide-fade">
                                <span v-if="isEmpresaMissing" class="badge badge-danger"> selecione </span>
                            </transition>
                        </a>
                    </li>
                    <li class="pulsate-regular">
                        <a href="#treeview_contas"
                           v-bind:class="{ 'not-active': (isContaTreeViewLoading() || !isContaEmpresaMestreRegra()) }"
                           data-toggle="tab">
                            <i class="fa fa-bank"></i> Contas <span v-if="(getTotalSelectedContas() > 0) && !isContaTreeViewLoading()"
                                                                    class="badge badge-default">{{ getTotalSelectedContas() }}</span>
                            <transition name="slide-fade">
                                <span v-if="isContaTreeViewLoading()" class="fa fa-spinner fa-spin"></span>
                            </transition>
                        </a>
                    </li>
                    <li>
                        <a href="#treeview_cc" v-bind:class="{ 'not-active': notActiveCCRules() }" data-toggle="tab">
                            <i class="fa fa-money"></i> CC <span v-if="(getTotalSelectedCC() > 0) && !isCCTreeViewLoading()" class="badge badge-default">
                                {{ getTotalSelectedCC() }}
                            </span>
                            <transition name="slide-fade">
                                <span v-if="isCCTreeViewLoading()" class="fa fa-spinner fa-spin"></span>
                            </transition>
                        </a>
                    </li>
                    <li>
                        <a href="#treeview_projetos"
                           v-bind:class="{ 'not-active': ( !isProjetoEmpresaMestreRegra()) }"
                           data-toggle="tab">
                            <i class="fa fa-line-chart"></i> Projetos <span v-if="(getTotalSelectedProjetos() > 0) && !isProjetoTreeViewLoading()" class="badge badge-default"> {{getTotalSelectedProjetos()}} </span>
                            <transition name="slide-fade">
                                <span v-if="!isProjetoEmpresaMestreRegra()" class="fa fa-spinner fa-spin"></span>
                            </transition>
                        </a>
                    </li>
                    <li>
                        <a href="#treeview_avancado" data-toggle="tab"><i class="fa fa-gears"></i> Avançado
                        </a>
                    </li>
                    <li>
                        <a href="#treeview_perfil" data-toggle="tab"><i class="fa fa-bookmark"></i> Perfil de Filtro
                        </a>
                    </li>
                </ul>
            </div>
            <div class="col-md-9">
                <div class="tab-content">
                    <div class="tab-pane active" id="treeview_empresaFilial">
                        <wes-treeview :key="`${chaveUnicaPerfilSelecionado}-1`" :store="getTreeViewEmpresaFilial()" treeview-id="empresaFilial" button="circle"
                            endpoint="empresaFilialSelecionadaAutorizada"
                            v-on:item-selected="itemSelected($event, tabInfo.empresaFilial)" v-on:loaded="setTotalTreeViews"
                            v-on:unloaded="setUnloadedTreeView" :markAllByDefault="true" />
                    </div>
                    <div class="tab-pane fade" id="treeview_contas">
                        <div class="row">
                            <div class="col-md-6">
                                <wes-treeview-select :key="`${chaveUnicaPerfilSelecionado}-2`" ref="treeviewSelectContas" :store="getTreeViewContas()"
                                    v-on:menu-item-selected="menuItemSelected"
                                    v-on:lookup-item-selected="lookupItemSelected" treeview-id="contas"
                                    :definitions="contaDefinitions"
                                    v-on:item-selected="itemSelected($event, tabInfo.contas)"
                                    v-on:tree-view-loaded="setTotalTreeViews"
                                    v-on:tree-view-unloaded="setUnloadedTreeView" />
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="treeview_cc">
                        <div class="row">
                            <div class="col-md-12">
                                <label class="label-title">Exibir lançamentos sem Centros de Custos informados (NI)</label>
                                <wes-switch :value="getExibirCentrosCustoNulos()" v-on:change="exibirCentrosCustoNulosChanged"></wes-switch>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6" style="padding-top: 10px">
                                <wes-treeview-select :key="`${chaveUnicaPerfilSelecionado}-3`" ref="treeviewSelectCC" :store="getTreeViewCentroDeCustos()" :markAllByDefault="true"
                                    v-on:menu-item-selected="menuItemSelected"
                                    v-on:lookup-item-selected="lookupItemSelected" treeview-id="CC" :definitions="ccDefinitions"
                                    v-on:item-selected="itemSelected($event, tabInfo.centroDeCustos)"
                                    v-on:tree-view-loaded="setTotalTreeViews"
                                    v-on:tree-view-unloaded="setUnloadedTreeView" />
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="treeview_projetos">
                        <div class="row">
                            <div class="col-md-12">
                                <label class="label-title">Exibir lançamentos sem Projetos informados (NI)</label>
                                <wes-switch :value="getExibirProjetosNulos()" v-on:change="exibirProjetosNulosChanged"></wes-switch>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12" style="padding-top: 10px">
                                <div id="treeview_projetos_custom">
                                    <div id="treeview_projetos_custom_filtro"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="treeview_avancado" style="padding-top: 10px">
                        <label class="filtro-label-avancado">Origem do realizado</label>
                        <div>
                            <a href="javascript:;" class="btn btn-circle btn-xs"
                                v-bind:class="{ [colorSelected]: isOrigemRealizadoEnabled(0), [colorDeselected]: !isOrigemRealizadoEnabled(0) }"
                                v-on:click="selectOrigemRealizado(0)">
                                <i class="fa fa-money"></i> Financeiro
                            </a>
                            <a href="javascript:;" class="btn btn-circle btn-xs"
                                v-bind:class="{ [colorSelected]: isOrigemRealizadoEnabled(1), [colorDeselected]: !isOrigemRealizadoEnabled(1) }"
                                v-on:click="selectOrigemRealizado(1)">
                                <i class="fa fa-calculator"></i> Contabil
                            </a>
                        </div>
                        <br />
                        <transition name="slide-fade">
                            <div v-if="isOrigemRealizadoEnabled(0)">
                                <a href="javascript:;" class="btn btn-circle btn-xs"
                                    v-bind:class="{ [colorSelected]: isTipoOrcamentoEnabled(0), [colorDeselected]: !isTipoOrcamentoEnabled(0) }"
                                    v-on:click="selectTipoOrcamentoEnabled(0)">
                                    <i class="fa fa-bank"></i> Visão econômica
                                </a>
                                <a href="javascript:;" class="btn btn-circle btn-xs"
                                    v-bind:class="{ [colorSelected]: isTipoOrcamentoEnabled(1), [colorDeselected]: !isTipoOrcamentoEnabled(1) }"
                                    v-on:click="selectTipoOrcamentoEnabled(1)">
                                    <i class="fa fa-money"></i> Visão financeira
                                </a>
                                <hr />
                                <label class="filtro-label-avancado">Data do realizado financeiro</label>
                                <div>
                                    <a href="javascript:;" class="btn btn-circle btn-xs"
                                        v-bind:class="{ [colorSelected]: isDataRealizadoFinanceiro(0), [colorDeselected]: !isDataRealizadoFinanceiro(0) }"
                                        v-on:click="selectDataRealizadoFinanceiro(0)">
                                        <i class="fa fa-calendar-minus-o"></i> Vencimento
                                    </a>
                                    <a href="javascript:;" class="btn btn-circle btn-xs"
                                        v-bind:class="{ [colorSelected]: isDataRealizadoFinanceiro(1), [colorDeselected]: !isDataRealizadoFinanceiro(1) }"
                                        v-on:click="selectDataRealizadoFinanceiro(1)">
                                        <i class="fa fa-calendar-check-o"></i> Pagamento (todos)
                                    </a>
                                    <a href="javascript:;" class="btn btn-circle btn-xs"
                                        v-bind:class="{ [colorSelected]: isDataRealizadoFinanceiro(2), [colorDeselected]: !isDataRealizadoFinanceiro(2) }"
                                        v-on:click="selectDataRealizadoFinanceiro(2)">
                                        <i class="fa fa-calendar"></i> Pagamento (tesouraria)
                                    </a>
                                </div>
                                <hr />
                            </div>
                        </transition>
                        <label class="filtro-label-avancado">Percentuais</label>
                        <div>
                            <a href="javascript:;" class="btn btn-circle btn-xs"
                                v-bind:class="{ [colorSelected]: isPercentuaisEnabled(0), [colorDeselected]: !isPercentuaisEnabled(0) }"
                                v-on:click="selectPercentuais(0)">
                                <i class="fa fa-percent"></i> (Realizado/Orçado)
                            </a>
                            <a href="javascript:;" class="btn btn-circle btn-xs"
                                v-bind:class="{ [colorSelected]: isPercentuaisEnabled(1), [colorDeselected]: !isPercentuaisEnabled(1) }"
                                v-on:click="selectPercentuais(1)">
                                <i class="fa fa-percent"></i> (Realizado/Orçado)-100
                            </a>
                        </div>
                        <hr />
                        <label class="filtro-label-avancado">Fórmula saldo</label>
                        <div>
                            <a href="javascript:;" class="btn btn-circle btn-xs"
                                v-bind:class="{ [colorSelected]: isFormulaSaldoEnabled(0), [colorDeselected]: !isFormulaSaldoEnabled(0) }"
                                v-on:click="selectFormulaSaldo(0)">
                                <i class="fa fa fa-calculator"></i> Orçado - Realizado
                            </a>
                            <a href="javascript:;" class="btn btn-circle btn-xs"
                                v-bind:class="{ [colorSelected]: isFormulaSaldoEnabled(1), [colorDeselected]: !isFormulaSaldoEnabled(1) }"
                                v-on:click="selectFormulaSaldo(1)">
                                <i class="fa fa fa-calculator"></i> Realizado - Orçado
                            </a>
                        </div>
                        <hr />
                        <div v-if="exibeFiltrosDoOrcamentoPublico">
                            <div class="row filtros-orcamento-grade">
                                <div class="col-md-6">
                                    <label class="filtro-label-avancado">Tipo de gastos</label>
                                    <!-- Seleção única; o option vazio é o placeholder do select2. -->
                                    <select ref="tipoGasto" class="form-control">
                                        <option value=""></option>
                                        <option value="1">Governamental</option>
                                        <option value="2">Institucional</option>
                                        <option value="3">Operacional</option>
                                    </select>
                                    <hr />
                                </div>
                                <!-- Completa a linha: a grade é preenchida por linha e lookupItems vem intercalado em pares. -->
                                <div class="col-md-6"></div>
                                <div v-for="(item, index) in lookupItems" :key="index" class="col-md-6">
                                    <label class="filtro-label-avancado">{{ item.label }}</label>
                                    <wes-lookup-multiple :ref="item.ref"
                                                         :entityName="item.entityName"
                                                         resultFields="NOME"
                                                         :placeholders="getPlaceHoldersCustom(item.label)"
                                                         :enabled="isTreeViewLoaded()"
                                                         v-on:change="selecionarLookupAvancado(item, $event)"
                                                         v-on:clear="selecionarLookupAvancado(item, [])"
                                                         v-on:mounted="lookupAvancadoMontado(item)">
                                    </wes-lookup-multiple>
                                    <hr />
                                </div>
                                <!-- Filtros declarados pelo específico (vazio no produto). -->
                                <div v-for="campo in camposExtras" :key="campo.nome" class="col-md-6">
                                    <label class="filtro-label-avancado">{{ campo.titulo }}</label>
                                    <wes-lookup-multiple v-if="campo.tipo === 'Lookup'"
                                                         :ref="refDoCampoExtra(campo)"
                                                         :entityName="campo.lookupEntidade"
                                                         :resultFields="campo.lookupCampoResultado"
                                                         :placeholders="getPlaceHoldersCustom(campo.titulo)"
                                                         :enabled="isTreeViewLoaded()"
                                                         v-on:change="selecionarCampoExtra(campo, $event)"
                                                         v-on:clear="selecionarCampoExtra(campo, [])">
                                    </wes-lookup-multiple>
                                    <select v-else
                                            :ref="refDoCampoExtra(campo)"
                                            multiple
                                            class="mt-multiselect form-control select2-lookup-multiple">
                                        <option v-for="item in campo.itens"
                                                :key="item.valor"
                                                :value="item.valor">
                                            {{ item.texto }}
                                        </option>
                                    </select>
                                    <hr />
                                </div>
                            </div>
                        </div>
                        <transition name="slide-fade">
                            <div v-if="isOrigemRealizadoEnabled(1)">
                                <label class="filtro-label-avancado">Considerar Comprometido</label>
                                <div>
                                    <wes-switch :value="isConsideraComprometido()"
                                        v-on:change="consideraComprometidoChanged"></wes-switch>
                                </div>
                            </div>
                        </transition>
                    </div>
                    <div class="tab-pane fade" id="treeview_perfil" style="padding-top: 10px">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Nome do perfil</label>
                                    <input type="text" class="form-control" id="nomePerfil" :value="nomePerfil" @input="setNomePerfil">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>&nbsp;</label>
                                    <div class="form-actions">
                                        <a class="btn btn-info" v-on:click.prevent="persistirPerfil()">
                                            <i class="fa fa-save"></i> {{ isPerfilSistema() ? "Salvar cópia de perfil pré-definido" : "Salvar perfil" }}
                                        </a>
                                        <a class="btn btn-danger" v-if="perfilSelecionado() && !isPerfilSistema()" v-on:click.prevent="excluirPerfil()">
                                            <i class="fa fa-times"></i> Excluir perfil
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
    /* Flex em vez de float: campo mais alto não empurra o seguinte para a coluna errada. */
    .filtros-orcamento-grade {
        display: flex;
        flex-wrap: wrap;
    }

    /* O clearfix do Bootstrap 3 viraria item flex. */
    .filtros-orcamento-grade:before,
    .filtros-orcamento-grade:after {
        display: none;
    }

    /* O wes-lookup-multiple força a busca a 200% e corta as etiquetas; aqui ela cabe na caixa. */
    .filtros-orcamento-grade .select2-lookup-multiple + span > span > span > ul > li > input.select2-search__field {
        width: 100% !important;
    }

    /* Quebra linha em vez de rolar: com nowrap a etiqueta aparece cortada à esquerda. */
    .filtros-orcamento-grade .select2-container .select2-selection--multiple .select2-selection__rendered {
        white-space: normal;
    }

    /* Campo vazio: o placeholder ocupa a caixa toda em vez de sair cortado. */
    .filtros-orcamento-grade .select2-container .select2-selection--multiple .select2-selection__rendered > li.select2-search--inline:first-child {
        width: 100%;
    }

    /* Nome longo quebra linha na etiqueta em vez de estourar o campo. */
    .filtros-orcamento-grade .select2-selection__choice {
        white-space: normal;
        max-width: 100%;
    }

    .filtro-gerenciais-actions {
        cursor: pointer !important;
    }

    .filtro-gerenciais-right-actions {
        float: right;
    }
    .img-tab {
        background-repeat: no-repeat;
        background-position: right bottom;
        background-size: cover;
    }

    .noUi-target {
        height: 10px
    }

    .gerenciais-font {
        padding: 0;
        margin: 0;
        line-height: 13px;
        color: #9eacb4;
        font-size: 13px;
        font-weight: 400;
    }

    .noUi-horizontal .noUi-handle {
        width: 24px;
        height: 20px;
    }

    .noUi-handle:before, .noUi-handle:after {
        height: 10px;
        width: 1px;
        left: 8px;
        top: 5px;
    }

    .noUi-handle:after {
        left: 14px;
    }

    .portlet-gerenciais-title {
        border-bottom: 1px solid #eee;
        padding: 0;
        margin-bottom: 1px;
        min-height: 41px;
        -webkit-border-radius: 4px 4px 0 0;
        -moz-border-radius: 4px 4px 0 0;
        -ms-border-radius: 4px 4px 0 0;
        -o-border-radius: 4px 4px 0 0;
        border-radius: 4px 4px 0 0;
    }

    .not-active {
        pointer-events: none;
        cursor: default;
        text-decoration: none;
        color: black;
    }

    .portlet-treeview {
        min-height: 300px;
    }
    /* Enter and leave animations can use different */
    /* durations and timing functions.              */
    .slide-fade-enter-active {
        transition: all .3s ease;
    }

    .slide-fade-leave-active {
        transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
        transform: translateX(10px);
        opacity: 0;
    }

    .filter-select-default {
        min-width: 280px;
    }
</style>

<script>
import OrcamentoService from "../../../services/OrcamentoService";
import { debug, debuglog } from 'util';
import GerenciaisService from "../../../services/GerenciaisService";

    export default {
        props: ["colorSelected", "colorDeselected", "plano", "versaoOrcamento", "dataInicio", "dataFim"],
        data: function () {
            return {
                endPointContas: "ct_contasgerenciais/plano/" + this.plano,
                isEmpresaMissing: false,
                isDateError: false,
                // No :key das treeviews: força a remontagem ao carregar um perfil, senão elas
                // mantêm a seleção anterior.
                chaveUnicaPerfilSelecionado: 0,
                // Guarda de reentrância: limpar um campo dispara o 'change' dele, que limparia o
                // outro lado da regra em cascata.
                aplicandoRegraCruzada: false,
                // Filtros declarados pelo específico (vazio no produto).
                camposExtras: [],
                // Na ordem da AN (duas colunas). storeKey é a chave em filtro.filtroAvancado e o
                // "campo" devolvido pelo endpoint de composição.
                lookupItems: [
                    { label: "Esfera Orçamentária", ref: "Esferas", storeKey: "esferas", entityName: "OP_ESFERA" },
                    { label: "Natureza da Despesa", ref: "NaturezasDespesa", storeKey: "naturezasDespesa", entityName: "OP_ELEMENTODESPESA" },
                    { label: "Funcional Programática", ref: "FuncionaisProg", storeKey: "funcionaisProgramaticas", entityName: "OP_FUNCIONALPROGRAMATICA" },
                    { label: "Categoria Econômica", ref: "CategoriasEcon", storeKey: "categoriasEconomicas", entityName: "OP_CATEGORIAECONOMICA" },
                    { label: "Função", ref: "Funcoes", storeKey: "funcoes", entityName: "OP_FUNCOES" },
                    { label: "Grupo de natureza", ref: "GruposNatureza", storeKey: "gruposNatureza", entityName: "OP_GRUPONATUREZA" },
                    { label: "Subfunção", ref: "Subfuncoes", storeKey: "subfuncoes", entityName: "OP_SUBFUNCOES" },
                    { label: "Modalidade de aplicação", ref: "ModalidadesAplic", storeKey: "modalidadesAplicacao", entityName: "OP_MODALIDADEAPLICACAO" },
                    { label: "Programa", ref: "Programas", storeKey: "programas", entityName: "OP_PROGRAMAS" },
                    { label: "Elemento de despesa", ref: "ElementosDespesa", storeKey: "elementosDespesa", entityName: "OP_DESPESA" },
                    { label: "Ação Orçamentária", ref: "AcoesOrcamentarias", storeKey: "acoesOrcamentarias", entityName: "OP_ACOES" },
                    { label: "Fonte de Recursos", ref: "FontesRecursos", storeKey: "fontesRecursos", entityName: "OP_FONTERECURSOS" },
                    { label: "Subtítulo", ref: "Subtitulos", storeKey: "subtitulos", entityName: "OP_SUBTITULOS" },
                    { label: "Projeto / Atividade / Op. Especial", ref: "ProjetosOrc", storeKey: "projetosOrcamentarios", entityName: "OP_PROJETOS" },
                    { label: "Despesa", ref: "Despesas", storeKey: "despesas", entityName: "OP_ACOESPROJETOS" }
                ],
                // Regras da AN: o pai preenche os filhos com um registro e os limpa com vários;
                // informar um filho limpa o pai.
                regrasComposicao: [
                    {
                        pai: "funcionaisProgramaticas",
                        filhos: ["funcoes", "subfuncoes", "programas", "acoesOrcamentarias", "subtitulos"],
                        obterComposicao: (handle) => OrcamentoService.getComposicaoFuncionalProgramatica(handle)
                    },
                    {
                        pai: "naturezasDespesa",
                        filhos: ["categoriasEconomicas", "gruposNatureza", "modalidadesAplicacao", "elementosDespesa"],
                        obterComposicao: (handle) => OrcamentoService.getComposicaoNaturezaDespesa(handle)
                    }
                ],
                tabInfo: {
                    empresaFilial: {
                        selected: 0,
                        total: 0
                    },
                    contas: {
                        selected: 0,
                        total: 0
                    },
                    centroDeCustos: {
                        selected: 0,
                        total: 0
                    },
                    projetos: {
                        selected: 0,
                        total: 0
                    }
                },
                contaDefinitions: [
                    {
                        caption: "Financeiras",
                        lookupEntityName: "fn_planoversoes",
                        treeviewFilterField: "versao",
                        treeviewEntityName: "fn_contas0"
                    }, {
                        caption: "Gerencias",
                        lookupEntityName: "ct_planosgerenciais",
                        treeviewFilterField: "plano",
                        treeviewEntityName: "ct_contasgerenciais0"
                    }],
                ccDefinitions: [
                    {
                        caption: "Padrão",
                        lookupEntityName: "",
                        treeviewFilterField: "",
                        treeviewEntityName: "ct_cc0"
                    }, {
                        caption: "Gerencias",
                        lookupEntityName: "ct_planosccgerenciais",
                        treeviewFilterField: "tipo",
                        treeviewEntityName: "ct_ccgerenciais0"
                    }],
                projetoDefinitions: [
                    {
                        caption: "Padrão",
                        lookupEntityName: "",
                        treeviewFilterField: "",
                        treeviewEntityName: "gn_projetos"
                    }, {
                        caption: "Gerencias",
                        lookupEntityName: "ct_planosprojetosgerenciais",
                        treeviewFilterField: "tipo",
                        treeviewEntityName: "ct_projetosgerenciais"
                    }]
            }
        },

        created: function () {
            OrcamentoService.getOrcamentoConsultaPlano("contas", this.versaoOrcamento).then(response => {
                this.$store.commit("treeview/setOrigem", { choice: "contas", origem: response.data });
            });
            OrcamentoService.getOrcamentoConsultaPlano("CC", this.versaoOrcamento).then(response => {
                this.$store.commit("treeview/setOrigem", { choice: "CC", origem: response.data });
            });
            OrcamentoService.getOrcamentoConsultaPlano("projetos", this.versaoOrcamento).then(response => {
                this.$store.commit("treeview/setOrigem", { choice: "projetos", origem: response.data });
            });
            this.$store.commit("filtro/setTipoGasto", "");
        },
        computed: {
            tipoGasto() {
                return this.$store.state.filtro.tipoGasto;
            },
            // Tipo de gastos, os 15 filtros e os do específico: Orçamento público e "Com Controle por
            // Ação Orçamentária".
            exibeFiltrosDoOrcamentoPublico() {
                return this.$store.state.filtro.visibilidadeOrcamento
                    && this.$store.state.filtro.controlePorAcaoOrcamentaria;
            },
            nomePerfil() {
                return this.$store.getters["filtro/getNomePerfil"];
            }
        },
        watch: {
            // O bloco só é desenhado depois das duas respostas, que podem chegar depois dos
            // descritores e do perfil: o select2 e a seleção precisam ser montados de novo.
            exibeFiltrosDoOrcamentoPublico(exibe) {
                if (!exibe)
                    return;

                this.$nextTick(() => {
                    this.inicializarTipoGasto();
                    this.inicializarListasDeCamposExtras();
                    this.restaurarFiltroAvancado();
                });
            },
            // Perfil carregado ou filtro limpo pelo store: o select2 não acompanha o Vuex sozinho.
            tipoGasto() {
                this.repintarTipoGasto();
            }
        },
        mounted() {
        OrcamentoService.getSituacaoEmpresaMestre()
            .then(response => {
                this.$store.commit("treeview/setEmpresasMestreRegras", response.data);
            });
        OrcamentoService.ehOrcamentoPublico()
            .then(response => {
                this.$store.commit("filtro/setVisibilidadeOrcamento", response.data);
            })
        OrcamentoService.getAcaoProjetoEhVisivel()
            .then(response => {
                this.$store.commit("filtro/setControlePorAcaoOrcamentaria", response.data);
            })
        OrcamentoService.getCamposExtras()
            .then(response => {
                this.camposExtras = response.data || [];
                this.sanearCamposExtras();
                this.zerarCamposExtrasSemPerfil();
                // $nextTick: o select2 precisa dos <select> já desenhados pelo v-for.
                this.$nextTick(() => this.inicializarListasDeCamposExtras());
            })

        this.$store.commit('filtro/setVersaoOrcamento', this.versaoOrcamento);
        this.$store.commit('treeview/resetTreeView', {choice: "acoesProjetos"});
        var self = this;
        this.$store.subscribe((mutation, state) => {
            if (mutation.type == 'treeview/setSelected') {
                if (self.$store.getters["treeview/getTotalSelectedContas"] === 0) {
                    self.$refs.treeviewSelectContas.clear();
                }
                if (self.$store.getters["treeview/getTotalSelectedCC"] === 0) {
                    self.$refs.treeviewSelectCC.clear();
                }
                if(self.$refs.treeviewSelectAcoesProjetos !== undefined)
                    self.$refs.treeviewSelectAcoesProjetos.clear();
            }
        });
            this.$store.commit("filtro/setTipoGasto", "");
            // Com o store restaurado do localStorage o bloco já nasce visível e o watch não dispara.
            this.$nextTick(() => this.inicializarTipoGasto());

        if (window.Sys && window.Sys.WebForms) {
            // setTimeout: roda depois dos demais tratadores do fim do postback.
            this.aoTerminarPostback = () => setTimeout(() => this.repintarTipoGasto(), 0);
            window.Sys.WebForms.PageRequestManager.getInstance().add_endRequest(this.aoTerminarPostback);
        }
    },
    // Uma nova renderização pode recriar o <select> sem o select2; inicializarTipoGasto ignora o já montado.
    updated() {
        this.inicializarTipoGasto();
    },
    beforeDestroy() {
        if (this.aoTerminarPostback)
            window.Sys.WebForms.PageRequestManager.getInstance().remove_endRequest(this.aoTerminarPostback);

        this.destruirTipoGasto();
        this.destruirListasDeCamposExtras();
    },
    methods: {
        getPlaceHoldersCustom(filtro) {
            return { enabled: "Selecionar " + filtro, disabled: "Aguarde o carregamento dos filtros." };
        },
        getLookupAvancado(ref) {
            const encontrado = this.$refs[ref];

            if (!encontrado)
                return null;

            // ref dentro de v-for chega como array.
            return Array.isArray(encontrado) ? encontrado[0] : encontrado;
        },
        // O multiselect zera o Vuex ao montar; com perfil carregado, preserva os handles dele.
        lookupAvancadoMontado(item) {
            if (this.perfilSelecionado())
                return;

            this.$store.commit('filtro/setFiltroAvancado', { campo: item.storeKey, handles: [] });
        },
        selecionarLookupAvancado(item, handles) {
            this.$store.commit('filtro/setFiltroAvancado', {
                campo: item.storeKey,
                handles: handles || []
            });

            if (this.aplicandoRegraCruzada)
                return;

            this.aplicarRegrasDeComposicao(item.storeKey, handles || []);
        },
        // Os campos extras não participam das regras cruzadas da AN.
        refDoCampoExtra(campo) {
            return 'CampoExtra_' + campo.nome;
        },
        sanearCamposExtras() {
            this.$store.commit('filtro/sanearCamposExtras',
                this.camposExtras.map((campo) => campo.nome));
        },
        // Como nos 15: sem perfil a tela abre vazia, ignorando o localStorage.
        zerarCamposExtrasSemPerfil() {
            if (this.perfilSelecionado())
                return;

            this.camposExtras.forEach((campo) => this.selecionarCampoExtra(campo, []));
        },
        valoresDoCampoExtra(campo) {
            const bloco = this.$store.state.filtro.filtroAvancado || {};
            const extras = bloco.camposExtras || {};

            return extras[campo.nome] || [];
        },
        selecionarCampoExtra(campo, handles) {
            this.$store.commit('filtro/setCampoExtra', {
                campo: campo.nome,
                valores: handles || []
            });
        },
        inicializarTipoGasto() {
            const elemento = this.$refs.tipoGasto;

            if (!elemento || window.$(elemento).data("select2"))
                return;

            window.$(elemento)
                .select2({
                    language: "pt-BR",
                    theme: "bootstrap",
                    width: "100%",
                    allowClear: true,
                    minimumResultsForSearch: Infinity,
                    placeholder: this.getPlaceHoldersCustom("Tipo de gastos").enabled
                })
                .on("change.tipoGasto", () => {
                    this.$store.commit('filtro/setTipoGasto', window.$(elemento).val() || "");
                });

            this.pintarTipoGasto(elemento);
        },
        // O postback parcial da grid de Projetos desfaz o select2 sem remover o <select>: remonta aqui.
        repintarTipoGasto() {
            const elemento = this.$refs.tipoGasto;

            if (!elemento)
                return;

            if (!window.$(elemento).data("select2")) {
                this.inicializarTipoGasto();
                return;
            }

            this.pintarTipoGasto(elemento);
        },
        pintarTipoGasto(elemento) {
            window.$(elemento)
                .val(String(this.tipoGasto || ""))
                .trigger("change.select2");
        },
        destruirTipoGasto() {
            const elemento = this.$refs.tipoGasto;

            if (elemento && window.$(elemento).data("select2"))
                window.$(elemento).off(".tipoGasto").select2("destroy");
        },
        camposExtrasDeLista() {
            return this.camposExtras.filter((campo) => campo.tipo !== 'Lookup');
        },
        inicializarListasDeCamposExtras() {
            this.camposExtrasDeLista().forEach((campo) => this.inicializarListaDeCampoExtra(campo));
        },
        inicializarListaDeCampoExtra(campo) {
            const elemento = this.getLookupAvancado(this.refDoCampoExtra(campo));

            // Já inicializado: de novo duplicaria o handler 'change.campoExtra'.
            if (!elemento || window.$(elemento).data("select2"))
                return;

            window.$(elemento)
                .select2({
                    language: "pt-BR",
                    theme: "bootstrap",
                    width: "100%",
                    allowClear: true,
                    placeholder: this.getPlaceHoldersCustom(campo.titulo).enabled
                })
                .on("change.campoExtra", () => {
                    const valores = (window.$(elemento).val() || []).map(Number);
                    this.selecionarCampoExtra(campo, valores);
                });

            // O perfil pode ter sido carregado antes de os descritores chegarem.
            this.repintarListaDeCampoExtra(campo);
        },
        // 'change.select2' só repinta: não dispara o 'change.campoExtra', que regravaria o Vuex.
        repintarListaDeCampoExtra(campo) {
            const elemento = this.getLookupAvancado(this.refDoCampoExtra(campo));

            if (!elemento)
                return;

            window.$(elemento)
                .val(this.valoresDoCampoExtra(campo).map(String))
                .trigger("change.select2");
        },
        destruirListasDeCamposExtras() {
            this.camposExtrasDeLista().forEach((campo) => {
                const elemento = this.getLookupAvancado(this.refDoCampoExtra(campo));

                if (elemento && window.$(elemento).data("select2"))
                    window.$(elemento).off(".campoExtra").select2("destroy");
            });
        },
        aplicarRegrasDeComposicao(storeKey, handles) {
            this.regrasComposicao.forEach((regra) => {
                if (regra.pai === storeKey) {
                    this.aplicarRegraDoPai(regra, handles);
                    return;
                }

                if (regra.filhos.indexOf(storeKey) >= 0 && handles.length)
                    this.limparCampoAvancado(regra.pai);
            });
        },
        aplicarRegraDoPai(regra, handles) {
            regra.filhos.forEach((filho) => this.limparCampoAvancado(filho));

            if (handles.length !== 1)
                return;

            regra.obterComposicao(handles[0])
                .then((response) => this.preencherFilhosDaComposicao(response.data))
                .catch(() => {
                    toastr.warning("Não foi possível carregar a composição do filtro selecionado.");
                });
        },
        preencherFilhosDaComposicao(itensComposicao) {
            this.executarSemRegraCruzada(() => {
                itensComposicao.forEach((composicao) => {
                    const item = this.lookupItems.find((lookup) => lookup.storeKey === composicao.campo);
                    const lookup = item ? this.getLookupAvancado(item.ref) : null;

                    if (!lookup)
                        return;

                    lookup.select({ handle: composicao.handle, nome: composicao.nome });
                    // O select2 não dispara 'change' num append manual.
                    this.$store.commit('filtro/setFiltroAvancado', {
                        campo: composicao.campo,
                        handles: [composicao.handle]
                    });
                });
            });
        },
        limparCampoAvancado(storeKey) {
            this.executarSemRegraCruzada(() => {
                const item = this.lookupItems.find((lookup) => lookup.storeKey === storeKey);
                const lookup = item ? this.getLookupAvancado(item.ref) : null;

                if (lookup)
                    lookup.clear();

                this.$store.commit('filtro/setFiltroAvancado', { campo: storeKey, handles: [] });
            });
        },
        executarSemRegraCruzada(acao) {
            this.aplicandoRegraCruzada = true;

            try {
                acao();
            } finally {
                this.aplicandoRegraCruzada = false;
            }
        },
        // Repinta os multiselects a partir dos handles do perfil; o texto vem do servidor.
        restaurarFiltroAvancado() {
            const filtroAvancado = this.$store.state.filtro.filtroAvancado || {};

            // Copia antes do clear(): o 'change' dele zera a lista no store.
            const handlesPorItem = this.lookupItems.map(
                (item) => (filtroAvancado[item.storeKey] || []).slice());

            this.executarSemRegraCruzada(() => {
                this.lookupItems.forEach((item, indice) => {
                    const lookup = this.getLookupAvancado(item.ref);

                    if (!lookup)
                        return;

                    lookup.clear();

                    const handles = handlesPorItem[indice];

                    if (!handles.length)
                        return;

                    OrcamentoService.getDescricoesLookup(item.entityName, handles)
                        .then((response) => {
                            this.executarSemRegraCruzada(() => {
                                response.data.forEach((descricao) => lookup.select(descricao));
                                // Os handles devolvidos, não os do perfil: cadastro excluído não volta.
                                this.$store.commit('filtro/setFiltroAvancado', {
                                    campo: item.storeKey,
                                    handles: response.data.map((descricao) => descricao.handle)
                                });
                            });
                        })
                        .catch(() => {
                            toastr.warning('Não foi possível carregar as descrições do filtro "' + item.label + '".');
                        });
                });
            });

            this.restaurarCamposExtras();
        },
        // Só o lookup precisa buscar o texto; as listas já têm os itens.
        restaurarCamposExtras() {
            this.sanearCamposExtras();

            this.camposExtrasDeLista().forEach((campo) => this.repintarListaDeCampoExtra(campo));

            this.camposExtras
                .filter((campo) => campo.tipo === 'Lookup')
                .forEach((campo) => {
                    const lookup = this.getLookupAvancado(this.refDoCampoExtra(campo));

                    if (!lookup)
                        return;

                    const handles = this.valoresDoCampoExtra(campo).slice();

                    lookup.clear();

                    if (!handles.length)
                        return;

                    OrcamentoService.getDescricoesLookup(campo.lookupEntidade, handles)
                        .then((response) => {
                            response.data.forEach((descricao) => lookup.select(descricao));
                            this.selecionarCampoExtra(campo, response.data.map((d) => d.handle));
                        })
                        .catch(() => {
                            toastr.warning('Não foi possível carregar as descrições do filtro "' + campo.titulo + '".');
                        });
                });
        },
        limparLookupsAvancados() {
            this.executarSemRegraCruzada(() => {
                this.lookupItems.forEach((item) => {
                    const lookup = this.getLookupAvancado(item.ref);

                    if (lookup)
                        lookup.clear();

                    this.$store.commit('filtro/setFiltroAvancado', { campo: item.storeKey, handles: [] });
                });
            });

            this.camposExtras.forEach((campo) => {
                const lookup = campo.tipo === 'Lookup'
                    ? this.getLookupAvancado(this.refDoCampoExtra(campo))
                    : null;

                if (lookup)
                    lookup.clear();

                this.selecionarCampoExtra(campo, []);
            });

            this.camposExtrasDeLista().forEach((campo) => this.repintarListaDeCampoExtra(campo));
        },
        getPlaceHoldersPerfil() {
            return { enabled: "Carregar configurações pré-definidas", disabled: "Aguarde o carregamento dos filtros." };
        },
        setNomePerfil(event) {
            this.$store.commit("filtro/setNomePerfil", event.target.value);
        },
        isPerfilSistema() {
            return this.$store.getters["filtro/isPerfilSistema"];
        },
        perfilSelecionado() {
            return this.$store.getters["filtro/getHandlePerfilSelecionado"] > 0;
        },
        selecionarLookupPerfil(perfil) {
            this.$refs.lookupPerfil.select(perfil);
            this.$store.commit('filtro/setHandlePerfilSelecionado', perfil.handle);
        },
        clearPerfil() {
            this.$refs.lookupPerfil.clear();
        },
        excluirPerfil() {
            OrcamentoService.deletePerfilOrcamento(this.$store.getters["filtro/getHandlePerfilSelecionado"])
                .then((response) => {
                    this.$store.commit("filtro/setNomePerfil", null);
                    this.clearPerfil();
                    toastr.success(response.data);
                })
                .catch((erro) => this.avisarFalhaPerfil(erro, "Não foi possível excluir o perfil."));
        },
        avisarFalhaPerfil(erro, mensagem) {
            const dados = erro ? erro.data || erro.body : null;
            const detalhe = dados ? dados.ExceptionMessage || dados.Message : null;

            toastr.error(detalhe ? mensagem + " " + detalhe : mensagem);
        },
        persistirPerfil() {
            if (!this.nomePerfil) {
                toastr.error("Para salvar uma configuração, informe o nome do perfil desejado.");
                return;
            }

            if (!this.isApplyEnabled())
                return;

            var orcamentoFiltroDTO = {
                filtro: this.$store.state.filtro,
                treeview: this.$store.state.treeview.treeview_selecoes.map((selecao) => {
                    return {
                        origem: selecao.origem,
                        tipo: selecao.tipo,
                        selected: selecao.selected
                    };
                }),
                projetos: this.montarFiltroProjetos()
            };

            OrcamentoService.postPerfilOrcamento(orcamentoFiltroDTO).then((response) => {
                if (response.data.handlePerfil !== this.$store.getters["filtro/getHandlePerfilSelecionado"])
                    this.selecionarLookupPerfil({
                        handle: response.data.handlePerfil,
                        nome: orcamentoFiltroDTO.filtro.nomePerfil
                    });

                toastr.success(response.data.mensagemRetorno);
            }).catch((erro) => this.avisarFalhaPerfil(erro, "Não foi possível salvar o perfil."));
        },
        selecionarPerfil(handlePerfil) {
            this.$store.commit('filtro/setHandlePerfilSelecionado', handlePerfil);

            OrcamentoService.getPerfilOrcamento(handlePerfil).then((response) => {
                this.$store.commit('treeview/setFromPerfil', response.data.treeview);
                this.$store.commit('filtro/loadPerfil', response.data.filtro);
                this.chaveUnicaPerfilSelecionado++;
                // A grid de projetos é ASP.NET: a seleção volta por postback (consultar.aspx.cs).
                CarregarPerfilProjetos();
                this.$nextTick(() => this.restaurarFiltroAvancado());
            }).catch((erro) => this.avisarFalhaPerfil(erro, "Não foi possível carregar o perfil."));
        },
        limparPerfilSelecionado() {
            this.$store.commit('filtro/setHandlePerfilSelecionado', 0);
            this.$store.commit('filtro/setNomePerfil', "");
            this.$store.commit('filtro/setSistema', false);
            // Os multiselects não remontam com chaveUnicaPerfilSelecionado: limpa à mão.
            this.limparLookupsAvancados();
        },
        isOrigemRealizadoEnabled(origemRealizado) {
            return this.$store.state.filtro.origemRealizado == origemRealizado;
        },
        selectOrigemRealizado(origemRealizado) {
            this.$store.commit('filtro/selectOrigemRealizado', origemRealizado);
        },
        isTipoOrcamentoEnabled(tipoOrcamento) {
            return this.$store.state.filtro.tipoOrcamento == tipoOrcamento;
        },
        selectTipoOrcamentoEnabled(tipoOrcamento) {
            this.$store.commit('filtro/selectTipoOrcamento', tipoOrcamento);
        },
        isDataRealizadoFinanceiro(dataRealizadoFinanceiro) {
            return this.$store.state.filtro.dataRealizadoFinanceiro == dataRealizadoFinanceiro;
        },
        selectDataRealizadoFinanceiro(dataRealizadoFinanceiro) {
            this.$store.commit('filtro/selectDataRealizadoFinanceiro', dataRealizadoFinanceiro);
        },
        isPercentuaisEnabled(percentuais) {
            return this.$store.state.filtro.percentuais == percentuais;
        },
        selectPercentuais(percentuais) {
            this.$store.commit('filtro/selectPercentuais', percentuais);
        },
        isFormulaSaldoEnabled(formulaSaldo) {
            return this.$store.state.filtro.formulaSaldo == formulaSaldo;
        },
        selectFormulaSaldo(formulaSaldo) {
            this.$store.commit('filtro/selectFormulaSaldo', formulaSaldo);
        },
        isConsideraComprometido(consideraComprometido) {
            return this.$store.state.filtro.consideraComprometido;
        },
        consideraComprometidoChanged(event, state) {
            this.$store.commit('filtro/selectConsideraComprometido');
        },
        getExibirCentrosCustoNulos() {
            return this.$store.state.filtro.exibirCentrosCustoNulos;
        },
        exibirCentrosCustoNulosChanged() {
            this.$store.commit('filtro/changeExibirCentrosCustoNulos');
        },
        getExibirProjetosNulos() {
            return this.$store.state.filtro.exibirProjetosNulos;
        },
        exibirProjetosNulosChanged() {
            this.$store.commit('filtro/changeExibirProjetosNulos');
        },
        isContaEmpresaMestreRegra() {
            return this.$store.getters["treeview/isContaMestreEnabled"];
        },
        notActiveCCRules() {
            return (this.isCCTreeViewLoading() || !this.isCCEmpresaMestreRegra());
        },
        isCCEmpresaMestreRegra() {
            return this.$store.getters["treeview/isCCMestreEnabled"];
        },
        isProjetoEmpresaMestreRegra() {
            return this.$store.getters["treeview/isProjetoMestreEnabled"];
        },
        getTreeViewContas() {
            return this.$store.getters["treeview/getContas"]
        },
        getTreeViewProjetos() {
            return this.$store.getters["treeview/getProjetos"];
        },
        getTreeViewCentroDeCustos() {
            return this.$store.getters["treeview/getCentroDeCustos"];
        },
        getTreeViewEmpresaFilial() {
            return this.$store.getters["treeview/getEmpresaFilial"];
        },
        getTotalSelectedContas(choice) {
            return this.$store.getters["treeview/getTotalSelectedContas"];
        },
        getTotalSelectedProjetos(choice) {
            return this.$store.getters["treeview/getTotalSelectedProjetos"];
        },
        getTotalSelectedEmpresaFilial(choice) {
            return this.$store.getters["treeview/getTotalSelectedEmpresaFilial"];
        },
        getTotalSelectedCC() {
            return this.$store.getters["treeview/getTotalSelectedCC"];
        },
        getTreeViewSelectStore() {
            return this.$store.state.treeview;
        },
        actionsClick: function () {
            e.stopPropagation();
            return e.preventDefault();
            //event.stopPropagation();
        },
        getStartDateValue() {
            if (!this.$store.state.options.startDate)
                    return null;
                return moment(this.$store.state.options.startDate, 'DD/MM/YYYY').toDate();
        },
        getEndDateValue() {
            if (!this.$store.state.options.endDate)
                return null;
            return moment(this.$store.state.options.endDate, 'DD/MM/YYYY').toDate();
        },
        getMaxDate() {
            if (this.dataFim === undefined || !this.dataFim)
                return null;
            return moment(this.dataFim, 'DD/MM/YYYY').toDate();
        },
        getMinDate() {
            if (this.dataInicio === undefined || !this.dataInicio)
                return null;
            return moment(this.dataInicio, 'DD/MM/YYYY').toDate();
        },
        getEmAbertoValue() {
            return this.$store.state.filtro.documentoEmAberto;
        },
        applyFilter(args) {
            this.isDateError = false;
            if (this.isApplyEnabled()) {
                this.$store.commit("options/setStartDate", args.start);
                this.$store.commit("options/setEndDate", args.end);

                var data = {
                    treeview: this.$store.state.treeview.treeview_selecoes.filter(x => x.id != "projetos" && x.data != 0),
                    filtro: this.$store.state.filtro,
                    startDate: args.start.toISOString().slice(0, 10),
                    endDate: args.end.toISOString().slice(0, 10),
                    projetos: this.montarFiltroProjetos()
                };

                window.$("#filtro-body").collapse("hide");
                this.$store.commit('pivotgrid/beginRequest');
                OrcamentoService.getOrcamentoConsultaPivotGrid(data).then(response => {
                    if (response.data.length === 0)
                        window.$("#filtro-body").collapse("show");
                    this.$store.commit('pivotgrid/endRequestSuccess', response.data);
                }, response => {
                    window.$("#filtro-body").collapse("show");
                    this.$store.commit('pivotgrid/endRequestError', response.data);
                });
            }
        },
        // Seleção da grid de projetos (fora do Vuex), no mesmo formato para "Gerar" e "Salvar perfil".
        montarFiltroProjetos() {
            const seletorGrid = $("#tipo_projeto")[0].value == "padrao" ?
                '#ctl00_Main_PROJETOS_SimpleGrid :checkbox:checked' :
                '#ctl00_Main_PROJETOS_GERENCIAIS_SimpleGrid :checkbox:checked';

            const projetos = $(seletorGrid)
                .toArray()
                .filter(proj => proj.value > 0)
                .map((e) => e.parentNode.parentNode.parentNode.attributes.handle.textContent);

            return {
                tipoProjeto: $('#tipo_projeto')[0].value,
                projetos: projetos,
                planoGerencial: $('#ctl00_Main_FILTRO_PROJETOS_GERENCIAIS_FilterControl_GERAL_ctl06_ctl01_select')[0].value
            };
        },
        adjustTreeViewFilter(tree_view){
            var tree_readonly = tree_view;
            tree_readonly.forEach((tree, idx) => {
                if(tree.data.count == undefined){
                    tree_view[idx].data = {
                        count: 0,
                        items: []
                    }
                }
            })
            return tree_view;
        },
        isApplyEnabled() {
            var result = true;
            var rules = [this.checkFiltroEmpresa()];
            for (var i in rules) {
                var current = rules[i];
                if (!current.condition()) {
                    current.showErrorMessage();
                    result = false;
                    break;
                }
            }
            return result;
        },
        checkFiltroEmpresa() {
            var result = {
                condition: this.isEmpresaSelected,
                showErrorMessage: this.showEmpresaNotSelectedMessage
            }
            return result;
        },
        showEmpresaNotSelectedMessage() {
            toastr.error("É necessário selecionar uma empresa para aplicar o filtro.");
            this.isEmpresaMissing = true;
        },
        isEmpresaSelected() {
            var r = this.$store.getters["treeview/isEmpresaSelected"];
            return r;
        },
        isEmpresaTreeViewLoading() {
            return this.$store.getters["treeview/isEmpresaTreeviewLoading"];
        },
        isContaTreeViewLoading() {
            return this.$store.getters["treeview/isContaTreeviewLoading"];
        },
        isCCTreeViewLoading() {
            return this.$store.getters["treeview/isCCTreeviewLoading"];
        },
        isProjetoTreeViewLoading() {
            return this.$store.getters["treeview/isProjetoTreeviewLoading"];
        },
        itemSelected: function (args, tabInfo) {
            var payload = {
                choice: args.id,
                selected: args.selected
            };
            if (payload.choice === "empresaFilial") {
                this.isEmpresaMissing = false;
            }
            this.$store.commit('treeview/setSelected', payload);
            tabInfo.selected = args.selected.length;
        },
        setUnloadedTreeView: function (payload) {
            this.$store.commit('treeview/setLoad', payload);
        },
        setTotalTreeViews: function (payload) {
            this.$store.commit('treeview/setLoad', { choice: payload.choice, loaded: true });
            this.$store.commit('treeview/setData', payload);
        },
        isTreeViewLoaded: function () {
            return this.$store.getters["treeview/isAllTreeviewLoaded"];
        },
        lookupItemSelected(payload) {
            this.$store.commit('treeview/setOrigem', payload);
        },
        menuItemSelected(payload) {
            this.$store.commit('treeview/setTipo', payload);
        },
        empresaSelected(payload) {
            this.isEmpresaMissing = false;
        },
        onErrorDateRange(payload) {
            toastr.error("A data inicial deve ser maior que a data final.");
            this.isDateError = true;
        }
    }
}
//# sourceURL=settings.vue
</script>
